import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { PaymentActivityTrackingTypeEnum } from '../enums/payment-activity-tracking-type.enum';

/**
 * Create payment activity tracking DTO
 */
export class CreatePaymentActivityTrackingDto {
	@TransformInt()
	paymentId!: number;
	type!: PaymentActivityTrackingTypeEnum;
	metadata!: Record<string, any>;
}
